export default function Btn({ children, variant = 'primary', size = 'md', icon, full, onClick, type, disabled, style }) {
  const base = {
    position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 9,
    fontFamily: 'var(--font-display)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em',
    border: 'none', cursor: disabled ? 'not-allowed' : 'pointer', whiteSpace: 'normal',
    maxWidth: '100%', minWidth: 0, boxSizing: 'border-box', lineHeight: 1.3, textAlign: 'center',
    transition: 'transform .14s var(--ease-out), box-shadow .2s, background .2s, color .2s',
    width: full ? '100%' : 'auto', opacity: disabled ? 0.45 : 1, userSelect: 'none',
    clipPath: 'polygon(10px 0, 100% 0, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0 100%, 0 10px)',
  };
  const sizes = {
    sm: { minHeight: 38, padding: '9px 18px', fontSize: 13 },
    md: { minHeight: 48, padding: '12px 26px', fontSize: 15 },
    lg: { minHeight: 58, padding: '16px clamp(18px, 5vw, 36px)', fontSize: 17 },
  };
  const variants = {
    primary: { background: 'linear-gradient(120deg, var(--accent-bright), var(--accent) 55%, var(--accent-deep))', color: '#fff', boxShadow: '0 10px 30px -10px var(--accent-glow), inset 0 1px 0 rgba(255,255,255,0.25)' },
    gold: { background: 'linear-gradient(120deg, #F2CC5E, var(--gold) 55%, var(--gold-deep))', color: '#1a1206', boxShadow: '0 10px 30px -12px rgba(230,183,60,0.5), inset 0 1px 0 rgba(255,255,255,0.4)' },
    ghost: { background: 'rgba(255,255,255,0.04)', color: 'var(--fg)', boxShadow: 'inset 0 0 0 1px var(--line-strong)' },
    outline: { background: 'transparent', color: 'var(--accent-bright)', boxShadow: 'inset 0 0 0 1.5px var(--line-accent)' },
    dark: { background: 'var(--surface-2)', color: 'var(--fg-soft)', boxShadow: 'inset 0 0 0 1px var(--line)' },
  };
  return (
    <button
      type={type || 'button'}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={{ ...base, ...sizes[size], ...variants[variant], ...style }}
      onMouseEnter={e => { if (!disabled) e.currentTarget.style.transform = 'translateY(-2px)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; }}
      onMouseDown={e => { if (!disabled) e.currentTarget.style.transform = 'translateY(0) scale(0.98)'; }}
      onMouseUp={e => { if (!disabled) e.currentTarget.style.transform = 'translateY(-2px)'; }}
    >
      {icon && <span style={{ display: 'inline-flex', flexShrink: 0 }} aria-hidden="true">{icon}</span>}
      <span style={{ minWidth: 0, overflowWrap: 'anywhere' }}>{children}</span>
    </button>
  );
}
